"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInteractableEntityCollidable = void 0;
const pixel_pigeon_1 = require("pixel-pigeon");
const retrommo_types_1 = require("retrommo-types");
const WorldCharacter_1 = require("../classes/WorldCharacter");
const getConstants_1 = require("./getConstants");
const definables_1 = require("definables");
const getWorldState_1 = require("./state/getWorldState");
const hasOpenedChest_1 = require("./hasOpenedChest");
const getNPCEntityCollidable = (direction, x, y) => {
    const constants = (0, getConstants_1.getConstants)();
    const npcCollisionData = (0, pixel_pigeon_1.getRectangleCollisionData)({
        entityTypes: ["npc", "npc-extender"],
        rectangle: {
            height: constants["tile-size"],
            width: constants["tile-size"],
            x,
            y,
        },
    });
    if (npcCollisionData.entityCollidables.length > 0) {
        const entityCollidable = npcCollisionData
            .entityCollidables[0];
        switch (entityCollidable.type) {
            case "npc":
                return entityCollidable;
            case "npc-extender": {
                let newX = x;
                let newY = y;
                switch (direction) {
                    case retrommo_types_1.Direction.Down:
                        newY += constants["tile-size"];
                        break;
                    case retrommo_types_1.Direction.Left:
                        newX -= constants["tile-size"];
                        break;
                    case retrommo_types_1.Direction.Right:
                        newX += constants["tile-size"];
                        break;
                    case retrommo_types_1.Direction.Up:
                        newY -= constants["tile-size"];
                        break;
                }
                return getNPCEntityCollidable(direction, newX, newY);
            }
        }
    }
    return null;
};
const getInteractableEntityCollidable = () => {
    const constants = (0, getConstants_1.getConstants)();
    const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, (0, getWorldState_1.getWorldState)().values.worldCharacterID);
    let x = worldCharacter.position.x * constants["tile-size"];
    let y = worldCharacter.position.y * constants["tile-size"];
    switch (worldCharacter.direction) {
        case retrommo_types_1.Direction.Down:
            y += constants["tile-size"];
            break;
        case retrommo_types_1.Direction.Left:
            x -= constants["tile-size"];
            break;
        case retrommo_types_1.Direction.Right:
            x += constants["tile-size"];
            break;
        case retrommo_types_1.Direction.Up:
            y -= constants["tile-size"];
            break;
    }
    const collisionData = (0, pixel_pigeon_1.getRectangleCollisionData)({
        entityTypes: ["bank", "chest", "combination-lock", "enterable", "piano"],
        rectangle: {
            height: constants["tile-size"],
            width: constants["tile-size"],
            x,
            y,
        },
    });
    if (collisionData.entityCollidables.length > 0) {
        const entityCollidable = collisionData.entityCollidables[0];
        if (typeof entityCollidable === "undefined") {
            throw new Error("Entity collidable is undefined");
        }
        if (entityCollidable.type === "chest") {
            const chestID = (0, pixel_pigeon_1.getEntityFieldValue)(entityCollidable.entityID, "chestID");
            if (typeof chestID !== "string") {
                throw new Error("No chest ID.");
            }
            if ((0, hasOpenedChest_1.hasOpenedChest)(chestID)) {
                return null;
            }
        }
        return entityCollidable;
    }
    return getNPCEntityCollidable(worldCharacter.direction, x, y);
};
exports.getInteractableEntityCollidable = getInteractableEntityCollidable;
